const Constants = {
  API: "https://addfriends.com/vip/actions/",
  //API: " http://192.168.86.39:4000/",
  RESET: "https://addfriends.com/reset/",
  APIL: "https://addfriends.com/brains/",
  CDN: "https://static.addfriends.com/",
  MA: "/vip/",
  COMMENT_POP_CLASS: "show_comment",
  HIDE_NAV: "hide_nav",
  DM_DESKTOP: "dm_desktop",
  AVATAR_URL: "https://static.addfriends.com/vip/avatars/",
  XSRF:
    "C4^RGy$#i!xGsY#l0ss35rreVo^zsvxpwFMSF1B6D6MFj#16m%AZsCjQyyWw0Y%cXgaslSKt1c",
};
export default Constants;
